<template>
  <div class="cart">
    <a :href="cartUrl">
      <div class="cart-image">
        <NsIcon
          :icon-name="iconName"
          color="#272525"
          size="icon-lg"
          style="width:100%; height:100%"
        />
        <span class="cart-count">{{ countDisplay }}</span>
      </div>
    </a>
  </div>
</template>

<script>
import { getConfiguration } from "@nuskin/configuration-sdk";
import { NsIcon } from "@nuskin/design-components";
import { EquinoxCartService } from "@nuskin/ns-shop";
import {
  ConfigService,
  events,
  RunConfigService,
  equinoxLocalStorage
} from "@nuskin/ns-util";

export default {
  name: "NsMinimalHeaderMiniCartVue",
  components: {
    NsIcon
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      localCount: 0
    };
  },
  computed: {
    cartCount() {
      return this.localCount || this.count || 0;
    },
    cartUrl() {
      // Cartservice doesn't work for this yet
      const { language, country } = RunConfigService.getRunConfig();
      return `/${country}/${language}/viewCart`;
    },
    countDisplay() {
      if (this.cartCount < 1) {
        return "";
      } else if (this.cartCount < 100) {
        return this.cartCount;
      } else {
        return 99;
      }
    },
    iconName() {
      if (this.cartCount < 1) {
        return "icon-largecart-empty";
      } else if (this.cartCount < 100) {
        return "icon-largecart-099";
      } else {
        return "icon-largecart-99p";
      }
    }
  },
  mounted: function() {
    const country = RunConfigService.getRunConfig().country;

    if (equinoxLocalStorage.isEquinoxEnabled()) {
      getConfiguration(["Equinox_Markets"], {
        country: country,
        environment: RunConfigService.getEnvironmentCode(),
        clientId: ConfigService.getMarketConfig().checkout.clientId
      }).then(config => {
        if (
          country === config.Equinox_Markets.country_code &&
          config.Equinox_Markets.active
        ) {
          const component = this;
          EquinoxCartService.getEquinoxCart().then(response => {
            component.localCount =
              response &&
              response.data &&
              response.data.value &&
              response.data.value.count;
          });
        }
      });
    }

    this.setupListener();
  },
  methods: {
    setupListener() {
      let that = this;
      events.subscribe(events.shop.CART_UPDATED, info => {
        if (info && info.cartInfo.qty !== undefined) {
          that.localCount = info.cartInfo.qty > 0 ? info.cartInfo.qty : 0;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

.cart {
  position: relative;
  top: 6px;
}
.cart a {
  display: inline-block;
  text-decoration: none !important;
  color: inherit;
}
.cart-count {
  font-size: 14px;
  text-align: center;
  font-weight: 700;
  position: absolute;
  width: 32px;
  height: auto;
  top: -4px;
  right: 0px;
  color: var(--color-primary-text);
}

.cart-image.cart-changed svg {
  animation: cartChanged 0.3s ease-in-out;
}

.cart-image {
  position: relative;
  height: 32px;
  width: 32px;
}

@keyframes cartChanged {
  0% {
    height: 32px;
    top: 0;
  }
  50% {
    height: 36px;
    top: -2px;
  }
  100% {
    height: 32px;
    top: 0;
  }
}
</style>
